'use strict';

var getDateParamKey = require('./getDateParamKey');

function deleteDateParam(params, key) {
  delete params[getDateParamKey(params, key)];
}

module.exports = deleteDateParam;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/internal/deleteDateParam.js
// module id = 518
// module chunks = 0